export default {
  locale: "en",
  name: "Properties",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [],
  },
};
